import * as T from 'three';

/**
 * Average a list of 3D Vectors
 * @param {T.Vector3[]} vectors List of vectors to average
 * @returns {T.Vector3} Average vector
 */
export function getAverageVector(vectors) {
    let avgVector = new T.Vector3(0, 0, 0)
    vectors.forEach(vector => {
        avgVector.add(vector)
    })
    avgVector.divideScalar(vectors.length)
    return avgVector;
}

/**
 * Given a list of timestamps, save the configuration
 * @param {Object} robotGroup RobotGroup with motion loaded in
 * @param {Number[]} times Configuration timestamps of current robot's motion
 * @returns 
 */
export function getRobotPositions(robotGroup, times) {
    let collisionGroups = []
    times.forEach(time => {
        let cGroup = []
        robotGroup.animationInterface.updateTime(time, true)
        robotGroup.dataInterface.updateCollisionSpheres()
        robotGroup.dataInterface.spheres.forEach(sphere => {
            let pos = sphere.getWorldPosition(new T.Vector3)
            cGroup.push(pos)
        })
        collisionGroups.push([time, cGroup])
    })
    robotGroup.animationInterface.updateTime(0, true)
    return collisionGroups
}

export function getForwardDirection(robotGroup) {
    const F_VECTOR_FACTOR = 2.5

    let basePos = robotGroup.robot.getWorldPosition(new T.Vector3())
    let eePos = robotGroup.getEndEffector().getWorldPosition(new T.Vector3())
    let forwardPosition = new T.Vector3()
    forwardPosition.subVectors(eePos, basePos)
    forwardPosition.normalize()
    forwardPosition.multiplyScalar(F_VECTOR_FACTOR)
    forwardPosition.add(basePos)

    // returns lookat, lookfrom
    return [basePos, forwardPosition]
}

export function measureCollision(group1, group2) {
    const RADIUS = 0.04
    let score = 0
    group1.forEach(sphere1 => {
        group2.forEach(sphere2 => {
            let distance = sphere1.distanceTo(sphere2)
            // console.log(distance)
            score += distance
        })
    })
    return score
}

export function filterClosePositions(collisionGroups) {
    for(let i = 0; i < collisionGroups.length - 1; i++) {
        score = measureCollision(collisionGroups[i], collisionGroups[i] + 1)
    }
}

export function createSeperations(collisionGroups, scores, maxSeperations, scoreThreshold) {
    let cuts = []
    // console.log("begin cutting")
    scores.forEach(score => {
        if(cuts.length < maxSeperations) {
            if(cuts.length == 0) {
                if(score[0] < scoreThreshold) { 
                    // first cut ends at the pose before the overlap
                    cuts.push(collisionGroups[score[4]-1][0])
                }
            }
            else {
                cuts.forEach(cut => {
                    // see if each side of pair is in same cut
                    if((cut - score[1]) * (cut - score[2]) >= 0) {
                        let exists = false
                        // see if the cut is already used
                        cuts.forEach(cut1 => {
                            if(cut1 == score[1] || cut1 == score[2]) {
                                exists = true
                            }
                        })
                        // is score is below threshold, cut doesn't already exist, and are not consecutive
                        if(score[0] < scoreThreshold && !exists && (score[4] != score[3] + 1)) {
                            // console.log(score)
                            cuts.push(score[2])
                        }
                    }
                })
            }
        }
    })

    // reorder
    for(let i = 0; i < cuts.length; i++) {
        let minIndex = i
        for(let k = i; k < cuts.length; k++) {
            if(cuts[k] < cuts[minIndex]) {
                minIndex = k
            }
        }
        let temp = cuts[i]
        cuts[i] = cuts[minIndex]
        cuts[minIndex] = temp
    }

    return cuts
}